module.exports = __webpack_public_path__ + "static/media/logo_SI_Scoring_white.4405a908.svg";